import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';
import { IconSanitizerService } from '../../services/icon-sanitizer.service';

@Component({
    selector: 'lib-trend-indicator',
    templateUrl: './trend-indicator.component.html',
    styleUrls: ['./trend-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IdGeneratorPipe]
})
export class TrendIndicatorComponent implements OnChanges {
    displayValue?: string;
    trendClass?: string;

    @Input()
    previousValue?: number;

    @Input()
    currentValue?: number;

    @Input()
    trendIndicatorId?: string;

    trendIndicatorPositiveIcon: SafeHtml;
    trendIndicatorNegativeIcon: SafeHtml;

    constructor(private readonly iconSanitizer: IconSanitizerService) {
        this.trendIndicatorPositiveIcon = this.iconSanitizer.getIcon('trendIndicatorPositive');
        this.trendIndicatorNegativeIcon = this.iconSanitizer.getIcon('trendIndicatorNegative');
        this.previousValue = 0;
        this.currentValue = 0;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['previousValue'] || changes['currentValue']) {
            this.calculatePercentageChange();
        }
    }

    calculatePercentageChange(): void {
        if (typeof this.currentValue === 'undefined' || typeof this.previousValue === 'undefined') {
            this.displayValue = '0%';
            this.trendClass = 'neutral';
            return;
        }

        if (this.previousValue === 0) {
            if (this.currentValue === 0) {
                this.displayValue = '0%';
                this.trendClass = 'neutral';
            } else {
                this.displayValue = '-%';
                this.trendClass = this.currentValue > 0 ? 'positive' : 'negative';
            }
            return;
        }

        const percentageChange = ((this.currentValue - this.previousValue) / Math.abs(this.previousValue)) * 100;

        if (percentageChange === 0) {
            this.displayValue = '0%';
            this.trendClass = 'neutral';
        } else {
            this.displayValue = `${Math.abs(percentageChange).toFixed(2)}%`;
            this.trendClass = percentageChange >= 0 ? 'positive' : 'negative';
        }
    }
}
